import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectHasReadSchedulePermission } from 'app/modules/session/selectors';
import { SCHEDULE_QUERY_KEYS } from 'app/modules/schedule/queries/keys';
import { ScheduleListResponse } from 'app/modules/schedule/responses';
import { get } from 'app/shared/utils/fetchr';

export const useGetAllSchedules = () => {
  const hasReadSchedulePermission = useSelector(
    selectHasReadSchedulePermission,
  );

  return useQuery({
    queryKey: SCHEDULE_QUERY_KEYS.getAllSchedules(),
    queryFn: () => get<ScheduleListResponse>('/schedules'),
    initialData: { schedules: [], count: 0 },
    enabled: hasReadSchedulePermission,
  });
};
